import tipoIndicadorReport from "./reports";
import tipoIndicadorReportSummary from "./reports/summary";

/**
 * Classe abstrata para representação de dados de tipos de indicadores de laudos.
 */
export default class TipoIndicador {
    constructor() {
        if (this.constructor === TipoIndicador) {
            throw new Error("TipoIndicador é uma classe abstrata e deve ser herdada");
        }
    }

    //
    // Métodos abstratos.
    //

    /**
     * Nome do dado ser exibido.
     */
    static get fullName() {
        throw new Error("static get fullName() deve ser definido com o nome do tipo de indicador");
    }

    /**
     * Abreviação do nome do indicador, usado como ID em alguns registros.
     */
    static get abbrev() {
        throw new Error("static get abbrev() deve ser definido com a abreviação do nome do tipo de indicador");
    }

    /**
     * Campo em que o dado é armazenado na collection.
     */
    static get field() {
        return this.abbrev.toLowerCase();
    }

    /**
     * Array de classes de indicadores deste tipo.
     */
    static get indicadores() {
        return [];
    }

    /**
     * Componente SvgIcon com o ícone do tipo de indicador.
     * Opcional.
     */
    static get icon() {
        return null;
    }

    //
    // Fim dos métodos abstratos.
    //

    /**
     * Carrega dados dos indicadores na visita.
     */
    static async onLoad(visita) {
        for (const IndicadorClass of this.indicadores) {
            const indicador = new IndicadorClass(this);
            await indicador.onLoad(visita);
        }
    }

    /**
     * Prepara dados dos indicadores para salvamento na visita.
     */
    static async preSave(visita) {
        for (const IndicadorClass of this.indicadores) {
            const indicador = new IndicadorClass(this);
            await indicador.preSave(visita);
        }
    }

    static async renderReport(visita) {
        return tipoIndicadorReport(this, visita);
    }

    static async renderReportSummary(visita) {
        return tipoIndicadorReportSummary(this, visita);
    }
}
